export default __webpack_public_path__ + "static/media/basic-duck.144da626.png";